import {getAction} from '@api/manage'

export const billMaterialSelectMixin = {
  data() {
    return {
      materialOptions: [],
      url: {
        queryMaterialByCodeOrName: "/bas/basMaterial/queryByCodeOrName",
      }
    };
  },
  methods: {
    initMaterialOptions(){
      const that = this
      getAction(this.url.queryMaterialByCodeOrName,{target:''}).then(res=>{
        if(res.success){
          that.materialOptions = []
          res.result.forEach((item)=>{
            that.materialOptions.push({value:item.id,label:item.name+'('+item.code+')'})
          })
        }
      })
    },
    handleMatrialChange(props,event){
      props.target.setValues([{
        rowKey: props.rowId,
        values: {materialId:event},
      }]);
      this.handleBatchNoSelect(props);
    },
    handleMatrialFocus(){
      this.materialOptions = []
    },
    findCodeByMaterialId(materialId){
      for(let i=0;i<this.materialOptions.length;i++){
        if(this.materialOptions[i].value == materialId){
          let tmpArr = this.materialOptions[i].label.split('(')
          return tmpArr[tmpArr.length - 1].replace(')','')
        }
      }
    },
    handleMatrialSearch(props,event,value){
      let that = this
      if(event.key=='Enter'){
        getAction(this.url.queryMaterialByCodeOrName,{target:event.target.value}).then(res=>{
          if(res.success){
            that.materialOptions = []
            res.result.forEach((item)=>{
              that.materialOptions.push({value:item.id,label:item.name+'('+item.code+')'})
            })
          }
        })
      }
    },
  },
}